// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": function componentCacheCachesGatsbyPluginOfflineAppShellJs() {
    return import("./../../.cache/caches/gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-js": function componentSrcPagesAboutJs() {
    return import("./../../src/pages/about.js"
    /* webpackChunkName: "component---src-pages-about-js" */
    );
  },
  "component---src-pages-hcp-404-js": function componentSrcPagesHcp404Js() {
    return import("./../../src/pages/hcp/404.js"
    /* webpackChunkName: "component---src-pages-hcp-404-js" */
    );
  },
  "component---src-pages-hcp-clinical-data-js": function componentSrcPagesHcpClinicalDataJs() {
    return import("./../../src/pages/hcp/clinical-data.js"
    /* webpackChunkName: "component---src-pages-hcp-clinical-data-js" */
    );
  },
  "component---src-pages-hcp-clinical-safety-profile-js": function componentSrcPagesHcpClinicalSafetyProfileJs() {
    return import("./../../src/pages/hcp/clinical-safety-profile.js"
    /* webpackChunkName: "component---src-pages-hcp-clinical-safety-profile-js" */
    );
  },
  "component---src-pages-hcp-dosing-and-administration-js": function componentSrcPagesHcpDosingAndAdministrationJs() {
    return import("./../../src/pages/hcp/dosing-and-administration.js"
    /* webpackChunkName: "component---src-pages-hcp-dosing-and-administration-js" */
    );
  },
  "component---src-pages-hcp-index-js": function componentSrcPagesHcpIndexJs() {
    return import("./../../src/pages/hcp/index.js"
    /* webpackChunkName: "component---src-pages-hcp-index-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-why-js": function componentSrcPagesWhyJs() {
    return import("./../../src/pages/why.js"
    /* webpackChunkName: "component---src-pages-why-js" */
    );
  },
  "component---src-pages-workflow-scenarios-js": function componentSrcPagesWorkflowScenariosJs() {
    return import("./../../src/pages/workflow-scenarios.js"
    /* webpackChunkName: "component---src-pages-workflow-scenarios-js" */
    );
  }
};